// src/pages/MonerisCheckoutPage.jsx
import React, { useEffect, useRef, useState } from 'react';
import courseService from '../../services/course.service';

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

export default function MonerisCheckoutPage() {
  const [status, setStatus] = useState('loading');
  const [msg, setMsg] = useState('');
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;

    (async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const checkoutId = params.get('checkoutId');
        const mode = (params.get('mode') || 'qa').toLowerCase(); // 'qa'|'prod'
        const orderId = params.get('orderId') || '';

        if (!checkoutId) throw new Error('checkoutId manquant');

        // Charger le JS Moneris selon l'environnement
        const scriptSrc = mode === 'prod'
          ? 'https://gateway.moneris.com/chkt/js/chkt_v1.00.js'
          : 'https://gatewayt.moneris.com/chkt/js/chkt_v1.00.js';
        await loadScript(scriptSrc);

        if (!window.monerisCheckout) throw new Error('monerisCheckout introuvable');

        const mco = window.monerisCheckout();
        mco.setMode(mode);
        mco.setCheckoutDiv('monerisCheckout');
        mco.startCheckout(checkoutId);

        // --- Callbacks requis (doc 2.6) ---
        mco.setCallback('page_loaded', (res) => {
          setStatus('ready');
          setMsg('Page Moneris chargée.');
          console.log('page_loaded', res);
        });

        mco.setCallback('cancel_transaction', (res) => {
          console.warn('cancel_transaction', res);
          setStatus('error'); setMsg('Transaction annulée.');
          // Optionnel: redirection dédiée
          // window.location.assign(`/payments/moneris/cancel?orderId=${encodeURIComponent(orderId)}`);
        });

        mco.setCallback('payment_complete', async (res) => {
          console.log('payment_complete', res);
          try {
            const receipt = await courseService.monerisVerifyReceipt({
              ticket: res?.ticket,
              checkoutId
            });
            if (receipt?.success) {
              setStatus('done'); setMsg('Paiement confirmé ✅');
              // Redirection succès
              // window.location.assign(`/payments/moneris/success?orderId=${encodeURIComponent(orderId)}`);
            } else {
              setStatus('error'); setMsg('Paiement non confirmé.');
              console.error('Receipt response', receipt);
              // window.location.assign(`/payments/moneris/error?orderId=${encodeURIComponent(orderId)}`);
            }
          } catch (e) {
            setStatus('error'); setMsg('Erreur de vérification du paiement.');
          }
        });

        mco.setCallback('payment_error', (err) => {
          console.error('payment_error', err);
          setStatus('error'); setMsg('Erreur de paiement.');
        });

      } catch (e) {
        console.error(e);
        setStatus('error');
        setMsg(e.message || 'Erreur d’initialisation.');
      }
    })();
  }, []);

  return (
    <div style={{ maxWidth: 520, margin: '40px auto' }}>
      <h2>Paiement Moneris</h2>
      <div id="monerisCheckout" />
      <div style={{ marginTop: 16 }}>
        {status === 'loading' && <span>Chargement…</span>}
        {msg && <div style={{ marginTop: 8 }}>{msg}</div>}
      </div>
    </div>
  );
}
